<template lang="pug">
div
    BaseHeader(
        icon='el-icon-plus',
        exibeBotao,
        :titulo='$t("mensagens.especialista.labels.titulo")',
        :voltarPara='{ route: "ConfiguracaoRastreabilidade" }',
        :btnTexto='$t("mensagens.especialista.labels.novoEspecialista")',
        @btnHeaderClicado='irParaCadastroEspecialista'
    )
    .especialistas
        .field
            i.el-icon-search.field__icon
            input.input-search.field__input(
                v-model='filtro',
                type='text',
                :placeholder='$t("mensagens.especialista.labels.placeholder")',
                autocomplete='off',
                @keyup.enter='listarEspecialistas'
            )
        .lista
            h3.lista__titulo {{ $t('mensagens.especialista.labels.listagem') }}
            el-table.lista__tabela(:key="listagemTableKey('especialistas', lista, paginacao.pagina + 1)", :data='lista')
                el-table-column(
                    prop='id',
                    label='ID ERP',
                    width='200',
                )
                    template(slot-scope='scope')
                        span {{ scope.row.idBunge || '-' }}
                el-table-column(
                    prop='nome',
                    :label='$t("mensagens.especialista.labels.nomeLabel")'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.nome || '-' }}

                el-table-column(
                    :label='$t("mensagens.especialista.labels.acao")',
                    :min-width='15',
                    align='center'
                )
                    .template(slot-scope='scope')
                        el-dropdown.action-button(trigger='click')
                            span.el-dropdown-link
                                i.mdi.mdi-dots-vertical
                            el-dropdown-menu(slot='dropdown')
                                el-dropdown-item(
                                    icon='el-icon-view',
                                    @click.native='irParaDetalhesEspecialista(scope.row)'
                                ) {{ $t('mensagens.especialista.labels.visualizar') }}
                                el-dropdown-item(
                                    icon='el-icon-edit',
                                    @click.native='irParaEdicaoEspecialista(scope.row)'
                                ) {{ $t('mensagens.especialista.labels.editar') }}
                                el-dropdown-item(
                                    icon='el-icon-delete',
                                    @click.native='confirmarRemocaoEspecialista(scope.row)'
                                ) {{ $t('mensagens.especialista.labels.excluir') }}
                template(slot='empty')
                el-empty(description='Não há especialistas')
            .paginacao
                span.total-paginas {{ formatarTotalPaginas(paginacao.total) }}
                el-pagination(
                    background,
                    layout='prev, pager, next',
                    :page-size='paginacao.itensPorPagina',
                    :current-page.sync='paginacao.pagina + 1',
                    :total='paginacao.total',
                    @current-change='listarEspecialistas'
                )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import services from '@/views/contratos-originacao/especialista/services';

export default {
    name: 'ConfiguracaoEspecialista',
    components: {
        BaseHeader
    },
    data() {
        return {
            filtro: '',
            pageable: {
                page: 0,
                size: 10,
                sort: 'nome',
                order: 'asc'
            },
            lista: [],
            paginacao: {}
        };
    },
    mounted() {
        this.listarEspecialistas();
    },
    methods: {
        async listarEspecialistas(page = 1) {
            this.pageable.page = page - 1;
            const params = {
                filtro: { nome: this.filtro },
                pageable: this.pageable
            };

            const { data } = await services.buscarEspecialistasPorFiltro(params);
            this.lista = data.especialistas;
            this.paginacao = data.paginacao;
        },
        irParaCadastroEspecialista() {
            this.$router.push({
                name: 'EspecialistaCadastro'
            });
        },
        irParaEdicaoEspecialista(row) {
            this.$router.push({
                name: 'EspecialistaEdicao',
                params: { id: row.id }
            });
        },
        irParaDetalhesEspecialista(row) {
            this.$router.push({
                name: 'EspecialistaDetalhes',
                params: { id: row.id }
            });
        },
        confirmarRemocaoEspecialista(row) {
            const confirmButtonText = this.$t('mensagens.comuns.sim');
            const cancelButtonText = this.$t('mensagens.comuns.cancelar');
            const aviso = this.$t('mensagens.comuns.aviso');
            const mensagemRemocao = this.$t(
                'mensagens.sistema.removerEspecialista'
            );

            return this.$messageBox
                .confirm(mensagemRemocao, aviso, {
                    confirmButtonText,
                    cancelButtonText,
                    type: 'warning'
                })
                .then(result => {
                    if (result === 'confirm') {
                        this.removerEspecialista(row);
                    }
                });
        },
        removerEspecialista(row) {
            const { id } = row;
            const mensagemSucesso = this.$t(
                'mensagens.especialista.labels.registroExcluido'
            );

            services.removerEspecialista({ id }).then(({ data }) => {
                if (data.includes('sucesso')) {
                    this.$notify.success(mensagemSucesso);
                    this.listarEspecialistas();
                }
            });
        },
        formatarTotalPaginas(total = 0) {
            const title =
                total > 1
                    ? this.$t('mensagens.especialista.labels.titulo')
                    : this.$t('mensagens.especialista.labels.tituloSingular');

            return `${total} ${title}`;
        }
    }
};
</script>

<style lang="scss" scoped>
.especialistas {
    margin: 20px;
    .field {
        display: flex;
        background-color: $white;
        padding: 7px 10px;
        border-radius: $default-border-radius;
        gap: 5px;
        align-items: center;
        @include default-box-shadow();

        &__icon {
            color: $primary;
        }
        &__input {
            border: none;
            outline: none;
            width: 100%;
            &:focus,
            &:active {
                border: none;
            }
        }
    }
    .lista {
        margin-top: 20px;
        &__titulo {
            margin-bottom: 5px;
        }
        .el-table {
            border-radius: 4px 4px 0 0;
            @include default-box-shadow();
        }
    }
    .paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        background-color: $white;
        border-radius: 0 0 4px 4px;
        padding: 15px;

        .total-paginas {
            color: $primary;
            font-weight: bold;
        }
    }
}
</style>
